import { KolLinkButton } from '@public-ui/react-v19';
import type { FC } from 'react';
import React from 'react';
import { SampleDescription } from '../SampleDescription';

export const LinkButtonAriaDescription: FC = () => (
	<>
		<SampleDescription>
			<p>This sample shows KolLinkButton with aria-description</p>
		</SampleDescription>

		<div className="flex flex-wrap gap-2">
			<KolLinkButton _href="#/back-page" _label="Link Button Text without area description"></KolLinkButton>
			<KolLinkButton _href="#/back-page" _label="Link Button Text" _ariaDescription="Link Button Aria Description"></KolLinkButton>
			<KolLinkButton
				_href="#/back-page"
				_label="Link Button Text"
				_ariaDescription="Link Button Aria Description with external Link"
				_target="_blank"
			></KolLinkButton>
		</div>
	</>
);
